/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Clear_TargetsInputs */

const cs_property_ai_clear_targets = /** @type {(inputs: Property_Ai_Clear_TargetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zrušit výběr`)
};

const en_property_ai_clear_targets = /** @type {(inputs: Property_Ai_Clear_TargetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear`)
};

/**
* | output |
* | --- |
* | "Clear" |
*
* @param {Property_Ai_Clear_TargetsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_clear_targets = /** @type {((inputs?: Property_Ai_Clear_TargetsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Clear_TargetsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_clear_targets(inputs)
	return cs_property_ai_clear_targets(inputs)
});